var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"KeybeLabel"},[_c('span',{style:({ color: _vm.$vuetify.theme.dark ? '#fff !important' : '#b3b6b9 !important' })},[_vm._v(_vm._s(_vm.text))]),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }